const ORG_STORAGE_KEY = 'zion_active_org_id';

/** Get the active organization ID from localStorage. Used by services outside React context. */
export function getActiveOrgId(): string | null {
  return localStorage.getItem(ORG_STORAGE_KEY);
}

/** Require the active org ID — throws if not set. Use in services that must be org-scoped. */
export function requireActiveOrgId(): string {
  const orgId = getActiveOrgId();
  if (!orgId) throw new Error('No active organization selected');
  return orgId;
}

/**
 * Apply org filter to a Supabase query, including records with NULL organization_id
 * as a fallback for legacy data that predates multi-org support.
 */
export function applyOrgFilter<T extends { or: (filter: string) => T; eq: (col: string, val: string) => T }>(
  query: T
): T {
  const orgId = getActiveOrgId();
  if (orgId) {
    return query.or(`organization_id.eq.${orgId},organization_id.is.null`);
  }
  return query;
}
